module.exports = __webpack_public_path__ + "static/media/ic_arrow_right.823eef7f.svg";